/**
 * Returns a black'ish or white'ish color depending on the brightness of the input hex color.
 */
export function getContrastColor(hexColor: string): string {
  // Remove the # if it exists
  const hex = hexColor.replace('#', '');

  // Convert hex to RGB
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  // Calculate relative luminance (WCAG)
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

  // If luminance > 0.5, use dark text, otherwise white
  return luminance > 0.5 ? '#464646' : '#f5f5f5';
}

/**
 * Darkens a hex color by a given percentage.
 *
 * @example
 * ```
 * darkenColor('#ff0000', 20); // returns a darker red
 * ```
 */
export function darkenColor(hexColor: string, percent: number): string {
  // Remove the # if it exists
  const hex = hexColor.replace('#', '');

  // Convert hex to RGB
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  // Darken by reducing each channel
  const darkR = Math.round(r * (1 - percent / 100));
  const darkG = Math.round(g * (1 - percent / 100));
  const darkB = Math.round(b * (1 - percent / 100));

  // Convert back to hex
  return `#${darkR.toString(16).padStart(2, '0')}${darkG.toString(16).padStart(2, '0')}${darkB.toString(16).padStart(2, '0')}`;
}
